var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaptopMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M604 128H420C400.125 128 384 144.125 384 164V476C384 495.875 400.125 512 420 512H604C623.875 512 640 495.875 640 476V164C640 144.125 623.875 128 604 128ZM576 448H448V192H576V448ZM128 64H448V96H512V48C512 21.5 490.5 0.125 464.125 0H111.875C85.5 0.125 64 21.5 64 48V288H16C7.125 288 0 295.125 0 304V320C0.125 355.25 28.625 383.875 63.875 384H352V288H128V64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopMobile);
export default __webpack_public_path__ + "static/media/laptop-mobile.fcf71d262bdaf7c7dc7bb7e6973dbb60.svg";
export { ForwardRef as ReactComponent };